const copyToClipboard = async (content) => {
  try {
    await navigator.clipboard.writeText(content);
  } catch (e) {
    throw new Error("Clipboard access on https and localhost only!");
  }
};
export {
  copyToClipboard
};
